import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import './Modal.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
};

const defaultProps = {
  isOpen: false,
  className: "",
  title: "",
};
const ReactStrapModal = ({ isOpen, toggleModal, className, children, title }) => {
  return (
    <div className="modal-container">
      <Modal isOpen={isOpen} toggle={toggleModal} className={className} size={'lg'}>
        <ModalHeader toggle={toggleModal}>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
      </Modal>
    </div>
  );
};
ReactStrapModal.propTypes = propTypes;
ReactStrapModal.defaultProps = defaultProps;

export default ReactStrapModal;